// Printable purchase / reorder list aggregated across all open orders + reorder buffers.
const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function buildPurchaseListHtml(suggestions, plantName = "H. K. INDUSTRIES (D-54)") {
  const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString(); } catch { return "—"; } };
  const rows = suggestions
    .map(
      (s) => `<tr>
        <td class="chk">☐</td>
        <td class="mono">${esc(s.sku)}</td>
        <td>${esc(s.name)}</td>
        <td>${esc(s.supplier) || "—"}</td>
        <td class="num">${s.lead_time_days ? esc(s.lead_time_days) + "d" : "—"}</td>
        <td class="num">${s.demand?.toLocaleString("en-IN")} ${esc(s.unit)}</td>
        <td class="num">${s.in_stock?.toLocaleString("en-IN")} ${esc(s.unit)}</td>
        <td class="num strong">${s.suggested_qty?.toLocaleString("en-IN")} ${esc(s.unit)}</td>
        <td class="num${s.overdue ? " overdue" : ""}">${fmtDate(s.latest_order_date)}${s.overdue ? " ⚠" : ""}</td>
      </tr>`
    )
    .join("");

  return `<!DOCTYPE html><html><head><title>Purchase List — ${esc(plantName)}</title><style>
    body { font-family: Arial, Helvetica, sans-serif; color: #0f172a; margin: 32px; }
    h1 { font-size: 18px; margin: 0 0 2px; }
    .sub { color: #64748b; font-size: 12px; margin-bottom: 20px; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th { text-align: left; text-transform: uppercase; font-size: 10px; letter-spacing: 0.05em;
         color: #64748b; border-bottom: 2px solid #0f172a; padding: 6px 8px; }
    td { border-bottom: 1px solid #e2e8f0; padding: 8px; }
    td.num, th.num { text-align: right; font-variant-numeric: tabular-nums; }
    td.strong { font-weight: 700; color: #1d4ed8; }
    td.overdue { color: #dc2626; font-weight: 700; }
    td.mono { font-family: "Courier New", monospace; }
    td.chk { font-size: 16px; width: 28px; }
    .foot { margin-top: 28px; font-size: 11px; color: #64748b; display: flex; justify-content: space-between; }
    .sign { margin-top: 40px; display: flex; gap: 60px; font-size: 11px; }
    .sign div { border-top: 1px solid #94a3b8; padding-top: 4px; width: 200px; }
  </style></head><body>
    <h1>Purchase / Reorder List — ${esc(plantName)}</h1>
    <p class="sub">${suggestions.length} material(s) to reorder · order quantity covers all open-order demand and restores the reorder-level buffer · Latest Order Date = need date − supplier lead time (red = already overdue) · printed ${new Date().toLocaleString("en-IN")}</p>
    <table>
      <thead><tr><th></th><th>SKU</th><th>Material</th><th>Supplier</th><th class="num">Lead</th><th class="num">Needed</th><th class="num">In Stock</th><th class="num">Order Qty</th><th class="num">Latest Order Date</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <div class="foot"><span>Order Qty = open-order demand + reorder level − current stock.</span><span>H. K. INDUSTRIES · Production Planning</span></div>
    <div class="sign"><div>Raised by / date</div><div>Approved by / date</div></div>
  </body></html>`;
}

function printHtml(html) {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  frame.srcdoc = html;
  frame.onload = () => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } finally {
      setTimeout(() => frame.remove(), 1000);
    }
  };
  document.body.appendChild(frame);
}

export function printPurchaseList(suggestions, plantName) {
  printHtml(buildPurchaseListHtml(suggestions, plantName));
}
